/** How a commission split applies — per contributor, not per account toggle */

export const COMMISSION_APPLICATION_TYPES = {
    account_default: 'Every deal on account',
    one_time: 'One-time',
    deal_specific: 'Specific deals only'
};

export const COMMISSION_APPLICATION_TYPE_ORDER = Object.keys(COMMISSION_APPLICATION_TYPES);

export function getCommissionApplicationTypeLabel(key) {
    return COMMISSION_APPLICATION_TYPES[key] || key;
}

/** Splits that new deals inherit when using account commission defaults */
export function getAccountDefaultSplits(splits) {
    return (splits || []).filter(s =>
        s.userId
        && s.splitPct > 0
        && (s.applicationType || 'account_default') === 'account_default'
    );
}
